module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/comments-83ec62a3166b40c59c0723ed52c3a5f7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/comments.svg
// module id = Qnnd
// module chunks = 24